import { 
    Form, 
    Input,
    Select,
    Row,
    Col,
    message,
    Modal
} from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import service from '../../../../../@services';
import './index.less'

const EditDeliveryNo = props => {
    const {
      visible,
      onClose,
      onGetDetail,
      detail = {}
    } = props

    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      }
    }
    const deliveryInfoId = detail.id
    const [deliveryCompany, setDeliveryCompany] = useState(detail.deliveryCompany)

    /* 物流公司列表 */
    const [companyDropdownList, setCompanyDropdownList] = useState([])
    
    /* 获取 物流公司（下拉列表） */
    const getCompanyDropdownList = async () => {
      service.delivery.companiesList().then(res => {
        if(res) {
          setCompanyDropdownList(res)
          setDeliveryCompany(detail.deliveryCompany)
        }
      })
    }
    const onSave = async () => {
      let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
      if(reg.test(form.getFieldsValue().deliveryCode)) {
        message.warning('物流单号仅支持输入字母和数字')
        return
      }

      const data = {
        deliveryInfoId,
        deliveryCompany,
        ...form.getFieldsValue()
      }
      const res = await service.orderSend.updateOrderDeliver(data)
      if(res) {
        message.success('修改成功')
        onGetDetail()
        onClose()
      }
    }
    /* 改变 物流公司 */
    const onChangeCompany = (e) => {
      companyDropdownList.forEach((element, index) => {
        if(element.companyNo == e) {
          setDeliveryCompany(element.deliveryCompany)
          form.setFieldsValue({
            companyNo: e,
            deliveryCode: ''
          })
        }
      })
    }
    /* 改变 物流单号 */
    const onChangeOrderNo = (e) => {
      e.target.value = e.target.value.trim()

      let reg = /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g;
      if(reg.test(e.target.value)) {
        message.warning('物流单号仅支持输入字母和数字')
      }

      form.setFieldsValue({
        ...form.getFieldsValue(),
        deliveryCode: e.target.value
      })
    }
  
    useEffect(() => {
      if (visible) {
        getCompanyDropdownList()
        form.setFieldsValue({
          deliveryCode: detail.deliveryCode,
          companyNo: detail.companyNo
        })
      } else {
        
      }
    }, [visible])
    return (
      <Modal
        title='修改单号'
        centered
        visible={visible}
        onOk={onSave}
        onCancel={onClose}
        width={480}
        className='editno-popup'
        okText="保存"
      >
        <Form form={form} {...formItemLayout}>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item 
                label='物流公司' 
                name="companyNo" 
                required
              >
                <Select placeholder="请选择物流公司" onChange={(e) => onChangeCompany(e)} >
                  {companyDropdownList.map((item, index) => (
                    <Select.Option value={ item.companyNo } key={ index }>
                      { item.deliveryCompany }
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={24}>
              <Form.Item 
                label='物流单号' 
                name="deliveryCode"
                required
              >
                <Input 
                  placeholder="请输入物流单号" 
                  value={form.deliveryCode} 
                  onChange={(e) => onChangeOrderNo(e)} 
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    )
  }
  export default connect(state => ({
  }))(EditDeliveryNo)